import React, { useContext } from 'react';
import {
  useDataModel, params, shape, arrayOf, string
} from '@thd-nucleus/data-sources';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ResultsHeader } from '../components/ResultsHeader';
import { useResultsRefUpdate } from '../hooks/useResultsRefUpdate';

export const PLPResultsHeader = ({ preamble }) => {

  const expContext = useContext(ExperienceContext);
  const { customContext } = expContext;
  const variables = { ...customContext?.variables || {} };
  const resultsRef = useResultsRefUpdate();
  const isHybridLayout = customContext?.isHybridLayout;
  const defaultOptions = {
    variables,
    ssr: true,
    skip: !variables.navParam && !variables.keyword
  };
  const { data, loading, error } = useDataModel('searchModel', defaultOptions);

  if (!data || (!data && loading) || (!data && error)) {
    return null;
  }

  return (
    <div className={isHybridLayout && 'sui-ml-2'}>
      <ResultsHeader
        preamble={preamble}
        resultsRef={resultsRef}
        dataProp={data}
      />
    </div>
  );
};

PLPResultsHeader.displayName = 'PLPResultsHeader';

PLPResultsHeader.propTypes = {
  preamble: PropTypes.node,
};

PLPResultsHeader.defaultProps = {
  preamble: null,
};

PLPResultsHeader.themeProps = {
  hideShopAllLink: PropTypes.bool
};

PLPResultsHeader.defaultThemeProps = {
  hideShopAllLink: false
};

PLPResultsHeader.dataModel = {
  searchModel: params({
    keyword: string(),
    navParam: string()
  }).shape({
    metadata: shape({
      contentType: string(),
      h1Tag: string()
    }),
    searchReport: shape({
      keyword: string(),
      correctedKeyword: string(),
      searchUrl: string()
    }),
    taxonomy: shape({
      breadCrumbs: arrayOf(shape({
        label: string(),
        url: string(),
        browseUrl: string(),
        dimensionName: string(),
        refinementKey: string()
      }))
    })
  })
};
